// extracted by mini-css-extract-plugin
module.exports = {"root":"DxgYf","itemClickWrapper":"_16yeN","imageZoomBtn":"_3lyqG","sizer":"_3GQLl","imageWrapper":"_2T78c","imageBorder":"M1RgI","image":"_2GSR9","overlay":"_2ZVCw"};